<template>
  <div id="giftbox-app" class="w-full min-h-full flex items-start justify-center bg-[#162550] sm:p-0 sm:items-stretch">
    <router-view />
  </div>
</template>

<script setup>
// Root component for GiftBox SPA
</script>

<style>
/* Global app styles - minimal, most styling via Tailwind */
html, body, #app {
  width: 100%;
  min-height: 100%;
  font-family: Inter, system-ui, -apple-system, sans-serif;
}

html {
  height: 100%;
}

body, #app {
  height: auto;
}
</style>
